module.exports = __webpack_public_path__ + "img/banner-left.95e7d843.png";